/** URL for a file in `public/images`, prefixed with the app's base path. */
export function imageUrl(path: string): string {
  // `import.meta.env` only exists under Vite; the API server (Node) falls back to `/`.
  return `${import.meta.env?.BASE_URL ?? '/'}images/${path}`;
}
